import { useEffect, useState } from "react";
import { useAddonsManager } from "./providers/AddonsManagerProvider";

export const AddonRenderer: React.FC = () => {
  const { currentStep, currentStepData, getAddonsForStep } = useAddonsManager();

  const [renderedComponents, setRenderedComponents] = useState<React.ReactNode[]>([]);

  useEffect(() => {
    const addonsForStep = getAddonsForStep(currentStep);

    const components = addonsForStep.map((addon, index) => <>{addon.render(currentStep, currentStepData)}</>);

    setRenderedComponents(components);
  }, [currentStep, currentStepData, getAddonsForStep]);

  return (
    <>
      {renderedComponents.length > 0 ? (
        renderedComponents
      ) : (
        <div className="row no-addons-message">No addons available for step: {currentStep}</div>
      )}
    </>
  );
};
